import * as yup from "yup";
import {stringRequired} from "../../../../../../yup/defaultValudations";

export const schema = yup.object().shape({
  description: stringRequired(),
});

export const initialValues = {description: ""};
